import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'
import { LineOtherIncomeComponent } from '../line-other-income/line-other-income.component';


@Component({
	selector: 'app-incomes-array',
	templateUrl: './incomes-array.component.html',
	styleUrls: ['./incomes-array.component.scss']
})



export class IncomesArrayComponent implements OnInit {
	@Input() public incomesFormArray: FormArray;
	@Input() public incomeTypes: string[];
	@Input() public displayErrors: boolean;
	@Input() public titles: string[];
	@Input() public needSources: boolean;
	@Output() onAddFormGroup: EventEmitter<any> = new EventEmitter<any>();
	@Input() public incomeType;
	@Output() onIncomesChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() public ph: string;
	@Input() public buttons: string[];
	@Input() addButtonOff = false;

	qID: number;
	maxIncomesCount = 2;

	constructor() { }

	ngOnInit() {
		//this.incomesFormArray.removeAt(0);//for removing the first line
	}

	emitIncomesChanges($event) {
		this.onIncomesChange.emit($event);
	}
	addIncome() {
		this.onAddFormGroup.emit();
		this.displayErrors = this.incomesFormArray.invalid;
		if (this.incomesFormArray.valid) {
			this.incomeTypes = this.incomeTypes.filter(name => name !== this.incomesFormArray.value[0].type);
			this.incomesFormArray.push(LineOtherIncomeComponent.buildIncome(''));
		}
	}

	simulateClick(event) {
		if (event.keyCode === 13) {
			event.currentTarget.click();
		}
	}

	changeInput(changeInput) {
		if (this.incomesFormArray.length > 1) {
			this.incomesFormArray.value.forEach(element => {
				this.incomeTypes = this.incomeTypes.filter(name => name !== element.type);
			});
		}
	}

	clickInput(changeInput) {
		if (this.incomesFormArray.length > 1) {
			this.incomesFormArray.value.forEach(element => {
				if (!this.incomeTypes.includes(element.type)) {
					if (element.type !== "") {
						this.incomeTypes.push(element.type);
					}
				}
			});
			this.incomeTypes = this.incomeTypes.filter(name => name !== this.incomesFormArray.value[(changeInput === 1 ? 0 : 1)].type);
		}
	}

	removeArr(removeArr) {
		this.clickInput(removeArr);
		this.incomesFormArray.removeAt(removeArr);
	}

	static buildIncomes(value: any) {
		let arr: FormGroup[] = [];
		if (value && value[0][0].answerValue) {
			value.forEach(element => {
				arr.push(LineOtherIncomeComponent.buildIncome(element));
			});
		}
		else {
			arr.push(LineOtherIncomeComponent.buildIncome(''));
		}
		return new FormArray(arr);
	}
}

// class incomesValidators {
// 	static minQuantitySum(val: number) {
// 	  return (c: AbstractControl) => {
// 		let sum = c.value
// 		  .map(income => income.amount)
// 		  .reduce((acc, cur) => acc + cur, 0 );
// 		if (sum < val) {
// 		  return { minSum: val }
// 		}
// 	  }
// 	}
//   }


// WEBPACK FOOTER //
// ./src/app/incomes-array/incomes-array.component.ts